import { HeaderBox } from 'component/basics';
import { colorEntryPointColorGreen } from 'component/color';
import { FakeTopicParticipantsWidget } from 'feature/topic/FakeParticipantCount';
import { component, demoFile } from 'system/demo';

demoFile('feature/topic/FakeParticipantCount');

const FakeTopicParticipantsWidgetDemo = () => (
    <HeaderBox backgroundColor={colorEntryPointColorGreen}>
        <FakeTopicParticipantsWidget />
    </HeaderBox>
);
component('FakeTopicParticipantsWidget', FakeTopicParticipantsWidgetDemo);
